module.exports = __webpack_public_path__ + "img/fuwuzhongxin1.7dfca389.png";